/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Duplicate.ts
 */

import APIError from "./APIError";

export default class Duplicate extends APIError {
    constructor(message: string) {
        super("Doublon", 409, message);
    }
}